<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <div class="row">
            <div class="col-12 mb-4">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">
                            {{ isEdicao ? 'Editar Intermediador de Pagamento' : 'Novo Intermediador de Pagamento' }}
                        </h1>
                        <p class="welcome-message">
                            <button mat-icon-button (click)="voltar()">
                                <mat-icon>arrow_back</mat-icon>
                            </button>
                            Preencha os detalhes do seu intermediador de pagamento.
                        </p>
                    </div>
                </div>
            </div>

            @if (isLoading) {
            <div class="col-12">
                <app-loading-box height="220"></app-loading-box>
            </div>
            } @else {
            <div class="col-12">
                <form [formGroup]="form">

                    <!-- Navegação por âncoras (sticky tabs) -->
                    <app-page-scroll-spy [sections]="sections"></app-page-scroll-spy>

                    <!-- ═══════════════════════════════════════════════════════════
                         SEÇÃO 1 — Informações básicas
                    ═══════════════════════════════════════════════════════════ -->
                    <div class="section-container" id="informacoes-basicas">
                        <div class="section-title">
                            <mat-icon>account_balance</mat-icon>
                            <span>Informações básicas</span>
                            @if (isEdicao && idContaFinanceiraVinculada) {
                            <div class="section-title-actions ms-auto">
                                <a class="vinculo-badge"
                                    [routerLink]="['/configuracoes/financas/contas-financeiras/cadastrar', idContaFinanceiraVinculada]"
                                    [matTooltip]="'Abrir conta financeira vinculada'">
                                    <mat-icon>account_balance_wallet</mat-icon>
                                    <span>Conta vinculada: {{ contaFinanceiraDescricao }}</span>
                                    <mat-icon class="vinculo-badge-arrow">open_in_new</mat-icon>
                                </a>
                            </div>
                            }
                        </div>

                        <div class="row">
                            <div class="col-md-6 col-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Intermediador</mat-label>
                                    <mat-select formControlName="idAdquirente">
                                        @for (adq of adquirentesDisponiveis; track adq.id) {
                                        <mat-option [value]="adq.id">{{ adq.descricao }}</mat-option>
                                        }
                                    </mat-select>
                                    @if (form.get('idAdquirente')?.touched &&
                                    form.get('idAdquirente')?.hasError('required')) {
                                    <mat-error>Selecione um intermediador.</mat-error>
                                    }
                                </mat-form-field>
                            </div>

                            <div class="col-md-6 col-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Descrição</mat-label>
                                    <input matInput formControlName="descricao" placeholder="Ex: Cielo Principal">
                                    @if (form.get('descricao')?.touched && form.get('descricao')?.hasError('required'))
                                    {
                                    <mat-error>A descrição é obrigatória.</mat-error>
                                    }
                                </mat-form-field>
                            </div>

                            <div class="col-md-6 col-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Conta financeira</mat-label>
                                    <input matInput [value]="contaFinanceiraDescricao" disabled
                                        placeholder="Preenchida automaticamente ao salvar">
                                    <mat-icon matSuffix class="tooltip-icon"
                                        matTooltip="Na criação, a conta financeira do tipo Recebimento é criada automaticamente com o mesmo nome do intermediador. Depois disso, os nomes podem ser alterados separadamente.">
                                        info_outline
                                    </mat-icon>
                                    <mat-hint>Conta de extrato do saldo disponível para o intermediador</mat-hint>
                                </mat-form-field>
                            </div>

                            <div class="col-md-6 col-12 toggle-field mt-3">
                                <mat-slide-toggle formControlName="isAtivo" color="primary">
                                    Ativo
                                </mat-slide-toggle>
                            </div>
                        </div>
                    </div>

                    <!-- ═══════════════════════════════════════════════════════════
                         SEÇÃO 2 — Configuração de tarifas
                    ═══════════════════════════════════════════════════════════ -->
                    <div class="section-container" id="configuracao-tarifas">
                        <div class="section-title">
                            <mat-icon>account_balance</mat-icon>
                            <span>Configuração de tarifas</span>
                        </div>

                        <div class="row">
                            <div class="col-md-4 col-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Tarifação</mat-label>
                                    <mat-select formControlName="idTipoTarifacao">
                                        @for (tipo of tiposTarifacaoDisponiveis; track tipo.id) {
                                        <mat-option [value]="tipo.id">{{ tipo.descricao }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            @if (isEmDiaEspecifico()) {
                            <div class="col-md-3 col-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Dia para débito</mat-label>
                                    <input matInput type="number" min="1" max="31" step="1" formControlName="diaDebito"
                                        class="no-spinner" placeholder="Ex: 15">
                                    @if (form.get('diaDebito')?.touched && form.get('diaDebito')?.hasError('required'))
                                    {
                                    <mat-error>Informe o dia para débito.</mat-error>
                                    }
                                    @if (form.get('diaDebito')?.hasError('min') ||
                                    form.get('diaDebito')?.hasError('max')) {
                                    <mat-error>O dia deve estar entre 1 e 31.</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                            }

                            @if (exibeCategoriaFinanceira()) {
                            <div class="col-md-5 col-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Categoria</mat-label>
                                    <mat-select formControlName="idCategoriaFinanceiraTarifa">
                                        @for (cat of categoriasFinanceirasDisponiveis; track cat.id) {
                                        <mat-option [value]="cat.id">{{ cat.descricao }}</mat-option>
                                        }
                                        @if (!categoriasFinanceirasDisponiveis.length) {
                                        <mat-option [value]="null" disabled>Nenhuma categoria disponível</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            }
                        </div>
                    </div>

                    <!-- ═══════════════════════════════════════════════════════════
                         SEÇÃO 3 — Configurações Sped
                    ═══════════════════════════════════════════════════════════ -->
                    <div class="section-container" id="configuracoes-sped">
                        <div class="section-title">
                            <mat-icon>account_balance</mat-icon>
                            <span>Configurações Sped</span>
                        </div>

                        <div class="row">
                            <div class="col-md-4 col-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>CNPJ da instituição</mat-label>
                                    <input matInput formControlName="cnpjInstituicao" [mask]="masks.cnpj"
                                        placeholder="00.000.000/0000-00">
                                </mat-form-field>
                            </div>

                            <div class="col-md-4 col-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Endereço da instituição</mat-label>
                                    <input matInput formControlName="enderecoInstituicao"
                                        placeholder="Rua, Número, Bairro">
                                </mat-form-field>
                            </div>

                            <div class="col-md-4 col-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Município da instituição</mat-label>
                                    <input matInput formControlName="municipioInstituicao" placeholder="Município - UF">
                                </mat-form-field>
                            </div>
                        </div>
                    </div>

                    <!-- ═══════════════════════════════════════════════════════════
                         SEÇÃO 4 — Configurações do Intermediador
                    ═══════════════════════════════════════════════════════════ -->
                    <div class="section-container" id="configuracoes-intermediador">
                        <div class="section-title">
                            <mat-icon>account_balance</mat-icon>
                            <span>Configurações do intermediador</span>
                        </div>

                        <div class="row">
                            <div class="col-md-4 col-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Bandeiras atendidas</mat-label>
                                    <mat-select formControlName="bandeiras" multiple>
                                        @for (b of bandeirasDisponiveis; track b.id) {
                                        <mat-option [value]="b.id">{{ b.descricao }}</mat-option>
                                        }
                                    </mat-select>
                                    <mat-hint>Gera as condições comerciais automaticamente</mat-hint>
                                </mat-form-field>
                            </div>

                            <div class="col-md-4 col-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Bandeira padrão</mat-label>
                                    <mat-select formControlName="idBandeiraPadrao"
                                        [disabled]="!bandeirasPadraoDisponiveis.length">
                                        @if (!bandeirasPadraoDisponiveis.length) {
                                        <mat-option [value]="null" disabled>Selecione primeiro as bandeiras
                                            atendidas</mat-option>
                                        }
                                        @for (b of bandeirasPadraoDisponiveis; track b.id) {
                                        <mat-option [value]="b.id">{{ b.descricao }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="col-md-4 col-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>
                                        Antecipação dos recebíveis
                                        <mat-icon class="tooltip-icon"
                                            matTooltip="Define como o intermediador realiza a antecipação dos valores a receber.">
                                            info_outline
                                        </mat-icon>
                                    </mat-label>
                                    <mat-select formControlName="idAntecipacaoRecebiveis">
                                        @for (ant of antecipacaoDisponiveis; track ant.id) {
                                        <mat-option [value]="ant.id">{{ ant.descricao }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="col-12 toggle-field">
                                <mat-slide-toggle formControlName="considerarProximoDiaUtil" color="primary">
                                    Considerar próximo dia útil para parcelas e tarifas
                                </mat-slide-toggle>
                            </div>
                        </div>
                    </div>

                    <!-- ═══════════════════════════════════════════════════════════
                         SEÇÃO 5 — Condições Comerciais
                    ═══════════════════════════════════════════════════════════ -->
                    <div class="section-container" id="condicoes-comerciais">
                        <div class="section-title">
                            <mat-icon>receipt_long</mat-icon>
                            <span>Condições comerciais das formas selecionadas</span>
                        </div>

                        <!-- Repassar taxas -->
                        <div class="row mb-3">
                            <div class="col-md-4 col-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Repassar taxas para o cliente</mat-label>
                                    <mat-select formControlName="idTipoRepasseTaxa">
                                        @for (op of tiposRepasseTaxaDisponiveis; track op.id) {
                                        <mat-option [value]="op.id">{{ op.descricao }}</mat-option>
                                        }
                                    </mat-select>
                                    <mat-hint>Exclusivo para o PDV</mat-hint>
                                </mat-form-field>
                            </div>

                            <div class="col-md-4 col-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Repassar taxas a partir da</mat-label>
                                    <mat-select formControlName="repassarTaxasAPartirDe">
                                        @for (p of parcelaOpcoes; track p.value) {
                                        <mat-option [value]="p.value">{{ p.label }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>

                        <!-- Grid de condições -->
                        <div formArrayName="condicoesComerciais">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <p class="grid-titulo">Condições cadastradas</p>
                                <button type="button" mat-button (click)="adicionarCondicaoManual()">
                                    <mat-icon>add</mat-icon> Adicionar
                                </button>
                            </div>

                            @for (row of condicoesComerciaisArray.controls; track $index; let i = $index) {
                            <div [formGroupName]="i" class="form-row-separator">
                                <div class="row">
                                    <div class="col-10 col-md-11">
                                        <div class="row g-2">
                                            <div class="col-6 col-lg-2">
                                                @if (row.get('isAutoGerado')?.value) {
                                                <mat-form-field appearance="outline" subscriptSizing="dynamic"
                                                    class="w-100 no-bottom-space compact-input">
                                                    <mat-label>Forma</mat-label>
                                                    <input matInput disabled
                                                        [value]="getFormaCondicaoLabel(row.get('idFormaRecebimento')?.value)">
                                                </mat-form-field>
                                                } @else {
                                                <mat-form-field appearance="outline" subscriptSizing="dynamic"
                                                    class="w-100 no-bottom-space compact-input">
                                                    <mat-label>Forma</mat-label>
                                                    <mat-select formControlName="idFormaRecebimento"
                                                        (selectionChange)="onFormaCondicaoChange(i)">
                                                        @for (f of formasDisponiveis; track f.id) {
                                                        <mat-option [value]="f.id">{{ f.descricao }}</mat-option>
                                                        }
                                                    </mat-select>
                                                </mat-form-field>
                                                }
                                            </div>

                                            <div class="col-6 col-lg-2">
                                                @if (row.get('isAutoGerado')?.value) {
                                                <mat-form-field appearance="outline" subscriptSizing="dynamic"
                                                    class="w-100 no-bottom-space compact-input">
                                                    <mat-label>Bandeira</mat-label>
                                                    <input matInput disabled
                                                        [value]="getBandeiraCondicaoLabel(row.get('idBandeira')?.value)">
                                                </mat-form-field>
                                                } @else {
                                                <mat-form-field appearance="outline" subscriptSizing="dynamic"
                                                    class="w-100 no-bottom-space compact-input">
                                                    <mat-label>Bandeira</mat-label>
                                                    <mat-select formControlName="idBandeira"
                                                        [disabled]="!aceitaBandeira(parseNullablePositiveInt(row.get('idFormaRecebimento')?.value))">
                                                        <mat-option [value]="null">—</mat-option>
                                                        @for (b of bandeirasDisponiveis; track b.id) {
                                                        <mat-option [value]="b.id">{{ b.descricao }}</mat-option>
                                                        }
                                                    </mat-select>
                                                </mat-form-field>
                                                }
                                            </div>

                                            <div class="col-6 col-lg-2">
                                                @if (row.get('isAutoGerado')?.value) {
                                                <mat-form-field appearance="outline" subscriptSizing="dynamic"
                                                    class="w-100 no-bottom-space compact-input">
                                                    <mat-label>Parcelado até</mat-label>
                                                    <input matInput disabled
                                                        [value]="getParceladoCondicaoLabel(row.get('idFormaRecebimento')?.value, row.get('parceladoAte')?.value)">
                                                </mat-form-field>
                                                } @else {
                                                <mat-form-field appearance="outline" subscriptSizing="dynamic"
                                                    class="w-100 no-bottom-space compact-input">
                                                    <mat-label>Parcelado até</mat-label>
                                                    <input matInput [currencyMask]="getDecimalMask(0)"
                                                        formControlName="parceladoAte">
                                                </mat-form-field>
                                                }
                                            </div>

                                            <div class="col-6 col-lg-2">
                                                <mat-form-field appearance="outline" subscriptSizing="dynamic"
                                                    class="w-100 no-bottom-space compact-input">
                                                    <mat-label>Prazo (dias)</mat-label>
                                                    <input matInput [currencyMask]="getDecimalMask(0)"
                                                        formControlName="prazo">
                                                </mat-form-field>
                                            </div>

                                            <div class="col-6 col-lg-2">
                                                <mat-form-field appearance="outline" subscriptSizing="dynamic"
                                                    class="w-100 no-bottom-space compact-input">
                                                    <mat-label>Taxa (%)</mat-label>
                                                    <input matInput formControlName="taxa" placeholder="0,00"
                                                        [currencyMask]="getDecimalMask(2)">
                                                </mat-form-field>
                                            </div>

                                            <div class="col-6 col-lg-2">
                                                <mat-form-field appearance="outline" subscriptSizing="dynamic"
                                                    class="w-100 no-bottom-space compact-input">
                                                    <mat-label>Tarifa</mat-label>
                                                    <input matInput formControlName="tarifa" placeholder="0,00"
                                                        [currencyMask]="tarifaMask">
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-2 col-md-1 produto-grid-delete-col">
                                        <button type="button" mat-icon-button class="produto-grid-delete-button"
                                            (click)="removerCondicao(i)" matTooltip="Remover linha">
                                            <mat-icon class="material-symbols-outlined">delete</mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            }

                            @if (condicoesComerciaisArray.length === 0) {
                            <app-empty-state icon="receipt_long" title="Nenhuma condição comercial cadastrada."
                                subtitle="Selecione as bandeiras atendidas ou clique em Adicionar para criar uma condição comercial.">
                            </app-empty-state>
                            }
                        </div>
                    </div>

                </form>
            </div>
            }
        </div>
    </div>
</div>

<app-footer-action [isLoadingSalvar]="isSaving" [isSalvarDisabled]="isLoading" (cancelar)="voltar()"
    (salvar)="salvar()">
</app-footer-action>